import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const PlayLeftIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3421 5.7592C16.1477 4.5536 15.7037 3.7312 15.0221 3.3144C14.3981 2.9336 13.5933 2.8984 12.6037 3.22C10.4157 4.1016 7.44291 5.964 5.69251 7.5472C4.86451 8.2752 4.44531 9.0336 4.44531 9.8016C4.44611 10.5696 4.86531 11.3272 5.68771 12.0496C7.44051 13.6376 10.4141 15.5008 12.6037 16.3832C12.6133 16.3864 12.6229 16.3904 12.6325 16.3928C13.0637 16.5296 13.4637 16.5984 13.8293 16.5984C14.2893 16.5984 14.6949 16.4904 15.0429 16.2744C15.7197 15.8552 16.1573 15.036 16.3445 13.8248C16.4893 12.5424 16.5589 11.188 16.5541 9.8024C16.5589 8.4144 16.4893 7.0608 16.3421 5.7592Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
    </svg>
  );
};

export default PlayLeftIcon;
